import React, { ReactNode } from 'react';

import mafraLogo from 'img/logo-grupo-mafra-branco.svg';
import ccareLogo from 'img/customer-care-logo.svg';
import melImage from 'img/mel.png';

import {
  PageWrapper,
  ContentWrapper,
  LogoContainer,
  WelcomeContainer,
  ContentContainer,
} from './styles';

const Login: React.FC<{ noBottomLogo?: boolean; children: ReactNode; }> = (props) => {
  const { children } = props;

  return (
    <PageWrapper>
      <ContentWrapper>
        <LogoContainer>
          <img src={mafraLogo} alt="Logo Viveo" />
          <img src={ccareLogo} alt="Logo Customer Care" />
        </LogoContainer>

        <WelcomeContainer>
          <img src={melImage} alt="Mel" />
          <div>
            <span />
            <h3>Bem-vindo ao Customer Care</h3>
            <p>
              O Customer Care é uma plataforma que irá facilitar o seu dia a dia
              com os processo e serviços da Viveo. Para entrar, use os
              campos abaixo:
            </p>
          </div>
        </WelcomeContainer>

        <ContentContainer>{children}</ContentContainer>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default Login;
